import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { subscriptionService, type CreateSubscriptionResponse } from '@/services/subscription/subscription.service';
import { useTranslation } from 'react-i18next';

export const useUpgradeSubscription = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return useMutation<CreateSubscriptionResponse, Error, string>({
    mutationFn: async (planId: string) => {
      const response = await subscriptionService.upgradeSubscription(planId) as CreateSubscriptionResponse | { data: CreateSubscriptionResponse };
      return 'data' in response ? response.data : response;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['subscription'] });
      queryClient.invalidateQueries({ queryKey: ['payments'] });
      
      const payment = data.payment || (data as { payment?: unknown }).payment;
      if (payment?.paymentLinkUrl) {
        try {
          window.open(payment.paymentLinkUrl, '_blank', 'noopener,noreferrer');
          toast.success(t('billing.toasts.upgradePaymentWindowOpened') || 'Payment window opened');
        } catch (error) {
          console.error('Failed to open payment window:', error);
          toast.error(t('billing.toasts.failedToOpenPaymentWindow') || 'Failed to open payment window');
        }
      } else {
        toast.warning(t('billing.toasts.paymentUrlMissing') || 'Payment URL not available');
      }
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || error?.message || t('billing.toasts.upgradeFailed') || 'Failed to upgrade subscription';
      toast.error(errorMessage);
    },
  });
};

